import * as React from 'react';
import MainSectionLayout from '../layout/MainSectionLayout';

export default class UnauthorizedPage extends React.Component {
  public render() {
    return <MainSectionLayout>YOU ARE NOT AUTHORIZED TO VIEW THIS PAGE</MainSectionLayout>;
  }
}
